import React from 'react';
import { SUBMISSION_PERIODS } from '../submissions/periodFormat';

export function KPISystemInfoTab({
  systemData,
  setSystemData,
  countryOptions,
  loading,
  onSave,
  onGoToDefinitions,
  onCancel,
  periodCounts = {},
}) {
  const enabled = systemData.enabled_periods || [];
  const togglePeriod = (p) => {
    const next = enabled.includes(p) ? enabled.filter((x) => x !== p) : [...enabled, p];
    setSystemData({ ...systemData, enabled_periods: next });
  };

  return (
    <form
      className="modal-form"
      onSubmit={(e) => {
        e.preventDefault();
        onSave(systemData);
      }}
      noValidate
    >
      <div className="form-group">
        <label htmlFor="system-info-name">System Name *</label>
        <input
          id="system-info-name"
          type="text"
          required
          value={systemData.name}
          onChange={(e) => setSystemData({ ...systemData, name: e.target.value })}
          maxLength={100}
        />
      </div>
      <div className="form-group">
        <label htmlFor="system-info-country">Country</label>
        <select
          id="system-info-country"
          value={systemData.country}
          onChange={(e) => setSystemData({ ...systemData, country: e.target.value })}
        >
          <option value="">Select a country…</option>
          {countryOptions.map((c) => (
            <option key={c.id} value={c.name}>
              {c.name}{c.isLegacy ? ' (legacy)' : ''}
            </option>
          ))}
        </select>
      </div>
      <div className="form-group">
        <label htmlFor="system-info-description">Description</label>
        <textarea
          id="system-info-description"
          value={systemData.description}
          onChange={(e) => setSystemData({ ...systemData, description: e.target.value })}
          maxLength={500}
        />
      </div>
      <div className="form-group">
        <label htmlFor="system-info-version">Version</label>
        <input
          id="system-info-version"
          type="text"
          value={systemData.version}
          onChange={(e) => setSystemData({ ...systemData, version: e.target.value })}
          pattern="^\d+(\.\d+){0,2}$"
          inputMode="decimal"
          title="Numeric only — e.g. 1, 1.0, or 1.0.0"
          aria-describedby="system-info-version-hint"
          maxLength={10}
        />
        <small id="system-info-version-hint">Numeric only — e.g. 1, 1.0, or 1.0.0</small>
      </div>
      <fieldset className="form-group kpi-periods">
        <legend>Enabled submission periods</legend>
        {SUBMISSION_PERIODS.map((p) => {
          const checked = enabled.includes(p);
          const removingWithData = !checked ? false : (periodCounts[p] || 0) > 0;
          return (
            <label key={p} htmlFor={`kpi-period-${p}`} className="kpi-period-row">
              <span className="kpi-period-name">{p}</span>
              <input id={`kpi-period-${p}`} type="checkbox" checked={checked} onChange={() => togglePeriod(p)} />
              {removingWithData && <span className="kpi-period-note">({periodCounts[p]} existing)</span>}
            </label>
          );
        })}
        {enabled.length === 0 && <small role="alert">Select at least one period.</small>}
        {SUBMISSION_PERIODS.some((p) => !enabled.includes(p) && (periodCounts[p] || 0) > 0) && (
          <small className="kpi-period-hint">Existing submissions in disabled periods are kept; no new ones can be created.</small>
        )}
      </fieldset>
      <div className="kpi-system-actions">
        <button type="submit" className="btn-primary" disabled={loading || enabled.length === 0}>
          Save System Info
        </button>
        <button
          type="button"
          className="btn-secondary"
          onClick={onGoToDefinitions}
          disabled={loading}
        >
          Go to KPI Definitions →
        </button>
        <button type="button" className="btn-secondary" onClick={onCancel} disabled={loading}>
          Cancel
        </button>
      </div>
    </form>
  );
}
